type GridCell = {
  element?: {
    type?: { _text?: string }
    grabVertical?: { _text?: string }
  }
  _isColspanPlaceholder?: boolean
  _isGridColumnSpacer?: boolean
  _isRowspanPlaceholder?: boolean
}

function isLabelCell(cell: GridCell | undefined): boolean {
  const t = String(cell?.element?.type?._text ?? '').trim().toLowerCase()
  return t === 'label'
}

function isSkippableCell(cell: GridCell | undefined): boolean {
  if (!cell) return true
  if (cell._isColspanPlaceholder || cell._isGridColumnSpacer || cell._isRowspanPlaceholder) {
    return true
  }
  if (!cell.element) return true
  return false
}

function isGrabVertical(cell: GridCell | undefined): boolean {
  const g = String(cell?.element?.grabVertical?._text ?? '').trim().toLowerCase()
  return g === 'true' || g === '1'
}

function countRealElements(items: GridCell[]): number {
  let n = 0
  for (const cell of items) {
    if (isSkippableCell(cell)) continue
    n++
  }
  return n
}

/**
 * Swing: Label with grabVertical=false has wantGrowHorizontally=false (weightx=0).
 * A lone label in the row hugs text and sits NORTHWEST — XML align=right is a no-op.
 * Hug the inner label only; the grid cell stays full row width (top-actions stay on the row).
 * Side-by-side label+field rows are unchanged (column already has width).
 */
export function shouldStandaloneLabelHug(items: GridCell[], itemIndex: number): boolean {
  const cell = items[itemIndex]
  if (!isLabelCell(cell)) return false
  if (isGrabVertical(cell)) return false
  if (countRealElements(items) !== 1) return false
  return true
}
